module.exports = __webpack_public_path__ + "img/Honigloeffel-v1-920.60e6e2ed.png";